<template>
    <div :class="['row', 'product-extras', name, className]">
        <div class="col-12">
            <div class="product-extras-header row">
                <!--<span class="separator"></span>-->
                <div class="col-12">
                    <h5 v-if="titel && titel.length > 0">{{titel}}</h5>
                </div>
                <!--<span class="separator"></span>-->
            </div>
            <div class="row">
                <div class="col-12 clearfix sly-parent">
                    <div class="product-extras-frame sly-frame horizontal">
                        <div class="product-extras-slidee sly-slidee" v-bind:style="{width: useSly ? width+'px' : ''}">
                            <!--<div class="product-extras-slidee sly-slidee">-->
                            <order-item-extra v-for="(extraId, index) in products"
                                              v-bind:key="extraId"
                                              v-bind:quantity="quantity(extraId, parentId)"
                                              v-on:extra-quantity-changed="extraQuantityChanged($event, index)"
                                              v-bind:product-id="extraId"
                                              v-bind:selection-type="selectionType"
                                              v-bind:list-index="index"
                                              v-bind:maximum-reached="groupedAmount !=0 && quantityAmountLeft == 0"
                                              v-bind:use-maximum="groupedAmount != 0">
                            </order-item-extra>

                            <div v-if="groupedAmount != 0" class="grouped-amount-remark">
                                Je mag nog {{  quantityAmountLeft }} producten kiezen
                            </div>
                            

                        </div>
                    </div>
                    <!--<div class="sly-arrow sly-arrow-right"><span class="icon icon-arrow-right">&#8250;</span></div>-->
                    <div class="sly-scrollbar"><div class="handle"></div></div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="separator fat-separator"></div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    /*****************************************************
     * order-item-extra-container.vue
     * Responsible for:
     * - rendering the sub items of an dish
     * - Sly initialisation
     ****************************************************/
    import orderItemExtra from './order-item-extra.vue'
    import translateService from '../Services/TranslateService';

    export default {

        props: {
            'products': Array                 // the products
            , 'name': String                  // the group name of the products (alias in Umbraco)
            , 'titel': String                 // The titel
            , 'quantity': Function            // The function from the parent scope
            , 'parentId': Number              // The parent id
            , 'className': String             // classname
            , 'selectionType': String          // The selection type,  radio , checkbox
            , 'useSly': Boolean               // A value indicating wheter to use sly or not
            , 'groupedAmount': {       // the maximum amount of all the products this container can have, a value of zero is normal behaviour
                type: Number, default: 0
            }
        },

        components: { orderItemExtra },

        data: function () {
            return {
                sly: null,
                frame: null,
                frameWidth: 0
            }
        },

        computed: {
            /** The width is depending an the amount of products */
            width: function () {
                return ((this.products.length * 168) - 10);
            },

            /** Returns the quantity left to order for this container (if groupedAmount > 0)*/
            quantityAmountLeft: function () {
                if (this.groupedAmount == 0) {
                    return 0;
                }
                return this.groupedAmount - this.totalQuantity;
            },

            /** Returns the total amount of quantity of all the products in this container */
            totalQuantity: function () {
                var totalQ = 0;
                
                this.products.forEach(a => {
                    totalQ += this.quantity(a, this.parentId);
                });

                return totalQ;
            }
        },

        methods: {
            /**
            * Pass through the quantity changed event
            * @param event
            */
            extraQuantityChanged: function (event, displayOrder) {

                event.displayOrder = displayOrder;
                this.$emit('extra-quantity-changed', event);

                let valid = true;

                if (this.groupedAmount > 0 && this.quantityAmountLeft > 0) {
                    valid = false;
                }

                this.$emit('validitychanged', { 'qchangedevent': event, 'valid': valid, 'parentId': this.name + "_" + this.parentId, 'message': translateService.getTranslation('QUANTITYNOTREACHED', "Verplicht aantal nog niet gekozen") });
            },

            /** Reload sly */
            reloadSly: function () {
                //this.loadSly();
                this.setDimension();
                //if (this.sly) {
                //    this.sly.reload();
                //}
            },

            /** initialize sly */
            loadSly: function () {


                this.frame = $(this.$el).find('.product-extras-frame');

                if (!this.useSly) {
                    this.frame.addClass('sly-inactive');
                    this.frame.parent().children('.sly-scrollbar').hide();
                } else {

                    // first destroy the previous version
                    if (this.sly) {
                        this.sly.destroy();
                    }
                    this.setDimension();


                    this.sly = new Sly(this.frame,
                        {
                            slidee: '.product-extras-slidee:not(.sly-inactive)',  // Selector representing SLIDEE, child of frame.
                            horizontal: true, // Switch to horizontal mode.

                            // Item based navigation
                            itemNav: 'basic',  // Item navigation type. Can be: 'basic', 'centered', 'forceCentered'.
                            itemSelector: '.product-item-extra',  // Select only items that match this selector.
                            smart: true, // Repositions the activated item to help with further navigation.
                            activateOn: 'click',  // Activate an item on this event. Can be: 'click', 'mouseenter', ...
                            //  activateMiddle: false, // Always activate the item in the middle of the FRAME. forceCentered only.
                            snapToItemsBorders: false,

                            // override item dimension
                            itemWidth: 158,
                            itemHeight: 209,

                            // Scrolling
                            //  scrollSource: null,  // Element for catching the mouse wheel scrolling. Default is FRAME.
                            //  scrollBy:     0,     // Pixels or items to move per one mouse scroll. 0 to disable scrolling.
                            //  scrollHijack: 300,   // Milliseconds since last wheel event after which it is acceptable to hijack global scroll.
                            scrollTrap: true, // Don't bubble scrolling when hitting scrolling limits.

                            // Dragging
                            //dragSource:    null,  // Selector or DOM element for catching dragging events. Default is FRAME.
                            mouseDragging: true, // Enable navigation by dragging the SLIDEE with mouse cursor.
                            touchDragging: true, // Enable navigation by dragging the SLIDEE with touch events.
                            releaseSwing: true, // Ease out on dragging swing release.
                            swingSpeed: 0.15,   // Swing synchronization speed, where: 1 = instant, 0 = infinite.
                            elasticBounds: true, // Stretch SLIDEE position limits when dragging past FRAME boundaries.
                            speedDivider: 2.5,
                            //interactive:   null,  // Selector for special interactive elements.

                            // Scrollbar
                            scrollBar: '.sly-scrollbar',  // Selector scrollbar container, child of parent of frame.
                            dragHandle: true, // Whether the scrollbar handle should be draggable.
                            dynamicHandle: true, // Scrollbar handle represents the ratio between hidden and visible content.
                            minHandleSize: 100,    // Minimal height or width (depends on sly direction) of a handle in pixels.
                            clickBar: true, // Enable navigation by clicking on scrollbar.
                            syncSpeed: 0.12,   // Handle => SLIDEE synchronization speed, where: 1 = instant, 0 = infinite.

                            // Pagesbar
                            //pagesBar:       null, // Selector pages bar container, child of parent of frame.
                            //activatePageOn: null, // Event used to activate page. Can be: click, mouseenter, ...

                            //pageBuilder:          // Page item generator.
                            //  function (index) {
                            //   return '<li>' + (index + 1) + '</li>';
                            //  },

                            // Navigation buttons
                            //backward: null, // Selector for "backward movement" button, child of parent of frame.
                            //forward:  null, // Selector for "forward movement" button, child of parent of frame.
                            //prev:     '.sly-arrow-left', // Selector for "previous item" button, child of parent of frame.
                            //prev:     null, // Selector for "previous item" button, child of parent of frame.
                            //next:     '.sly-arrow-right', // Selector for "next item" button, child of parent of frame.
                            //next:     null, // Selector for "next item" button, child of parent of frame.
                            // prevPage: null, // Selector or DOM element for "previous page" button.
                            // nextPage: null, // Selector or DOM element for "next page" button.

                            // Automated cycling
                            //cycleBy:       null,  // Enable automatic cycling by 'items' or 'pages'.
                            //cycleInterval: 5000,  // Delay between cycles in milliseconds.
                            //pauseOnHover:  false, // Pause cycling when mouse hovers over the FRAME.
                            //startPaused:   false, // Whether to start in paused sate.

                            // Mixed options
                            //moveBy:        300,     // Speed in pixels per second used by forward and backward buttons.
                            speed: 750,       // Animations speed in milliseconds. 0 to disable animations.
                            noAnimOnPhone: true,    // don't do animation on item activation on phone
                            //easing:        'swing', // Easing for duration based (tweening) animations.
                            //startAt:       null,    // Starting offset in pixels or items.
                            //keyboardNavBy: false,    // Enable keyboard navigation by 'items' or 'pages'.

                            // Classes
                            // HACK: default used to prevent mobile bug sly.js at the moment. //draggedClass:  'dragged', // Class for dragged elements (like SLIDEE or scrollbar handle).
                            activeClass: 'sly-active',  // Class for active items and pages.
                            disabledClass: 'sly-disabled' // Class for disabled navigation elements.
                        });
                    this.sly.init();
                    this.sly.toStart(true);
                }
            },

            setDimension: function () {

                var newWidth = this.frame.width();

                if (newWidth != this.frameWidth) {
                    this.frameWidth = this.frame.width();
                    var slideeWidth = this.width;
                    if (this.frameWidth >= slideeWidth) {
                        this.frame.addClass('sly-inactive');
                        this.frame.parent().children('.sly-scrollbar').hide();
                        return;
                    }

                    this.frame.parent().children('.sly-scrollbar').show();

                    if (this.sly) {
                        this.sly.reload();
                    }

                }
            }

        },

        watch: {

            /**
             * Reload sly when the products change    */
            "products.length": function () {
                var _this = this;
                process.nextTick(function () {
                    _this.loadSly();
                });
            }
        },

        mounted: function () {
            this.loadSly();
            var _this = this;
            $(window).on('resize', _this.reloadSly);

            // set max quantity as default, when there is only one product. 
            if (this.products.length == 1 && this.groupedAmount > 0) {
                this.$emit('extra-quantity-changed', { extraQuantity: this.groupedAmount, extraId: this.products[0], selectionType: this.selectionType });
            }

            var valid = true;
            if (this.groupedAmount > 0 && this.quantityAmountLeft > 0) {
                valid = false;
            }
            if (!valid) {
                this.$emit('validitychanged', { 'qchangedevent': null, 'valid': valid, 'parentId': this.name + "_" + this.parentId, 'message': translateService.getTranslation('QUANTITYNOTREACHED', "Verplicht aantal nog niet gekozen") });
            }
            
        },

        /** Clean up */
        beforeDestroy: function () {
            var _this = this;
            $(window).off('resize', _this.reloadSly);

            if (this.sly) {
                this.sly.destroy();
            }
        }
    }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/order-item-extra-container.vue